/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * PollIcon
 */
export default class PollIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M18 1a5 5 0 015 5v8a5 5 0 01-5 5H7.657a3 3 0 00-2.121.879l-2.829 2.828C2.077 23.337 1 22.891 1 22V6a5 5 0 015-5h12zm0 2H6a3 3 0 00-3 3v13.586l1.121-1.122A5 5 0 017.657 17H18a3 3 0 003-3V6a3 3 0 00-3-3zM6 5a1 1 0 01.993.883L7 6v8a1 1 0 01-1.993.117L5 14V6a1 1 0 011-1zm4 5a1 1 0 01.993.883L11 11v3a1 1 0 01-1.993.117L9 14v-3a1 1 0 011-1zm4-4a1 1 0 01.993.883L15 7v7a1 1 0 01-1.993.117L13 14V7a1 1 0 011-1zm4 2a1 1 0 011 1v5a1 1 0 01-2 0V9a1 1 0 011-1z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

